<template>
  <b-form class="col-md-12 px-0 page-section pt-0">
    <b-form-group label="Feedback" label-class="form-label">
      <b-form-checkbox v-model="simulation.requireFeedback" name="requireFeedback" switch>
        Is Automated Feedback required for each student's Interviews?
      </b-form-checkbox>
    </b-form-group>

    <b-form-group v-if="simulation.requireFeedback" label="Rubric Type" label-class="form-label">
      <v-select
        id="rubricType"
        class="form-control v-select-custom"
        :class="!$v.simulation.rubricType.required && $v.simulation.rubricType.$dirty ? 'form-control is-invalid' : ''"
        label="text"
        v-model="simulation.rubricType"
        :reduce="opt => opt.value"
        placeholder="Select Rubric Type"
        :options="rubricTypeOptions"
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>

        <template slot="option" slot-scope="option">
          <div class="d-flex align-items-center">
            <span>{{ option.text }}</span>
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          {{ option.text }}
        </template>
      </v-select>
      <b-form-invalid-feedback :state="!$v.simulation.rubricType.required && $v.simulation.rubricType.$dirty ? false : null"
          >This field is required.</b-form-invalid-feedback
        >
    </b-form-group>

    <b-form-group v-if="simulation.requireFeedback" label="Rubric" label-class="form-label">
      <b-form-textarea v-model="simulation.rubric" name="rubric" rows="8" :state="!$v.simulation.rubric.required && $v.simulation.rubric.$dirty ? false : null"></b-form-textarea>
      <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
    </b-form-group>
  </b-form>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import { pick } from 'lodash';
import { DEFAULT_RUBRIC_TEXT } from '@/common/constants';

export default {
  name: 'SimulationFeedbackForm',
  components: {},

  props: {
    simulationData: { type: Object, required: true },
  },

  data() {
    return {
      simulation: {
        requireFeedback: true,
        rubricType: '',
        rubric: '',
      },

      rubricTypeOptions: [
        { value: 'med-school', text: 'Med School' },
        { value: 'dental-school', text: 'Dental School' },
        { value: 'nursing-school', text: 'Nursing School' },
        { value: 'pa-school', text: 'PA School' },
        { value: 'pharmacy-school', text: 'Pharmacy School' },
        { value: 'optometry-school', text: 'Optometry School' },
        { value: 'physical-therapy-school', text: 'Physical Therapy School' },
        { value: 'occupational-therapy-school', text: 'Occupational Therapy School' },
        { value: 'certified-nursing-assistant-interview', text: 'Certified Nursing Assistant Interview' },
        { value: 'medication-aide-qmap-interview', text: 'Medication Aide QMAP Interview' },
        { value: 'phlebotomy-technician-interview', text: 'Phlebotomy Technician Interview' },
        { value: 'certified-ekg-technician-interview', text: 'Certified EKG Technician Interview' },
        { value: 'medical-assistant-interview', text: 'Medical Assistant Interview' },
        { value: 'patient-care-technician-interview', text: 'Patient Care Technician Interview' },
        { value: 'home-health-aide-interview', text: 'Home Health Aide Interview' },
        { value: 'medical-billing-coding-interview', text: 'Medical Billing Coding Interview' },
        { value: 'respiratory-therapist-interview', text: 'Respiratory Therapist Interview' },
        { value: 'emergency-medical-technician-interview', text: 'Emergency Medical Technician Interview' },
        { value: 'dental-assistant-interview', text: 'Dental Assistant Interview' },
        { value: 'orthodontist-assistant-interview', text: 'Orthodontist Assistant Interview' },
        { value: 'licensed-vocational-nursing-interview', text: 'Licensed Vocational Nursing Interview' },
        { value: 'restorative-nurse-aide-interview', text: 'Restorative Nurse Aide Interview' },
        { value: 'paramedic-interview', text: 'Paramedic Interview' },
        { value: 'physical-therapy-assistant-interview', text: 'Physical Therapy Assistant Interview' },
        { value: 'associate-degree-in-nursing-interview', text: 'Associate Degree in Nursing Interview' },
        { value: 'pharmacy-technician-interview', text: 'Pharmacy Technician Interview' },
        { value: 'sterile-processing-technician-interview', text: 'Sterile Processing Technician Interview' },
        { value: 'surgical-technician-interview', text: 'Surgical Technician Interview' },
        { value: 'medical-administrative-assistant-interview', text: 'Medical Administrative Assistant Interview' },
        { value: 'nursing-interview', text: 'Nursing Interview' },
        { value: 'dermatology-technician-interview', text: 'Dermatology Technician Interview' },
        { value: 'newborn-care-specialist-interview', text: 'Newborn Care Specialist Interview' },
        { value: 'mental-behavior-health-tech-interview', text: 'Mental Behavior Health Tech Interview' },
        { value: 'dialysis-technician-interview', text: 'Dialysis Technician Interview' },
        { value: 'proxy-care-interview', text: 'Proxy Care Interview' },
        { value: 'laboratory-testing-interview', text: 'Laboratory Testing Interview' },
      ],
    };
  },

  validations() {
    return {
      simulation: {
        requireFeedback: { required },
        rubricType: {
          required: requiredIf(() => this.simulation.requireFeedback),
        },
        rubric: {
          required: requiredIf(() => this.simulation.requireFeedback),
        },
      },
    };
  },

  computed: {},

  watch: {
    simulationData: {
      handler() {
        this.simulation = pick(this.simulationData, ['requireFeedback', 'rubricType', 'rubric']);
        this.simulation.rubric = this.simulation.rubric || DEFAULT_RUBRIC_TEXT;
      },
      deep: true,
    },
  },

  methods: {
    validateFormData() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
        formData: { ...this.simulation },
      };
    },
  },

  async mounted() {},
};
</script>
